import { ICountersPerEmloyee } from "./interfaces";
import { TnACounterDTO } from "../../../models/tna/tna-counters/tna-counter-dto";

export const getCountersPerEmloyee = (counters: TnACounterDTO[]): ICountersPerEmloyee => {
  if (!counters.length) return {};

  const res: ICountersPerEmloyee = {};

  counters.forEach((counter) => {
    const employeeId = counter.employee?.id;

    if (!employeeId) return;

    if (!res[employeeId]) {
      res[employeeId] = [counter];
    } else {
      res[employeeId].push(counter);
    }
  });

  return res;
};
